import React from "react";
import { useSelector } from "react-redux";
import { TextOverflow } from "utils/common";
import StatusColumn from "widgets/grid/cells/StatusColumn";
import { ProgressIndicator } from "rhombus-react";

import "./ConfirmPreviews.css";

export default function ConfirmPreviews({ title, desc, previews = []}) {
	const isLoading = useSelector(state => state.creativePreviews.isLoading);
	const renderRow = previews.map((preview)=>{
		return (
			<tr key={preview.id}>
				<td className="name-col"><TextOverflow value={preview.name} /></td>
				<td className="type-col"><StatusColumn value={preview.status} /></td>
			</tr>
		);
	});

	return (
		<div className="confirm-previews-container">
			<ProgressIndicator isLoading={isLoading} />
			<p className="confirm-previews-desc">{desc}</p>
			<table className="confirm-previews-table basic-table">
				<thead className="header">
					<tr className="headrow">
						<th className="name-col" scope="col">Name</th>
						<th scope="col">Status</th>
					</tr>
				</thead>
				<tbody>{renderRow}</tbody>
			</table>
		</div>
	);
}
